<template>
  <div class="mainCon">
    <NavBar>
      <template #left>
        <span />
      </template>
    </NavBar>
    <div class="innerCon">
      <div class="maintenance-search shop-search" @click="showArea=true">
        {{ areaName }}
        <van-icon name="arrow-down" />
      </div>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" class="shop-list-item" @click="$router.push('/shopDetail/'+item.shopId+'?distance='+item.distance)">
          <img :src="item.photoPath|| require('../../assets/default-icon.png')" alt="">
          <div class="shop-list-item-info">
            <h3 class="van-ellipsis">{{ item.shopName }}</h3>
            <!--<van-rate v-model="value" size="16px" color="#F25D24" readonly />-->
            <span>营业时间：{{ item.startTime }}-{{ item.endTime }}</span>
            <span style="max-width: 250px">门店地址：{{ item.provinceName }}{{ item.cityName }}{{ item.areaName }}{{ item.address }}</span>
            <span v-if="item.brands">维修品牌:<i v-for="i in item.brands.split(',')">{{ i }}</i></span>
            <span v-if="item.business">主营业务:<span v-for="i in item.business.split(',')">{{ i }}</span></span>
          </div>
          <div class="shop-list-item-button">
            <a href="javascript:;" class="icon-phone" @click.stop="phones(item.mobilePhone)" />
            <a href="javascript:;" class="icon-location" @click.stop="goLocation(item)" />
          </div>
          <div class="shop-list-item-location">
            <span v-if="Number(item.distance)>1" style="color: #999;margin-left: 10px;">{{ item.distance }}km</span>
            <span v-else style="color: #999;margin-left: 10px;">{{ item.distance*1000 }}m</span>
          </div>
        </div>
      </van-list>
    </div>
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-placeholder="['', '', '全部地区']"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>
<script>
import { getShopList } from '../../api/shop'
import area from '../../utils/area.json'

export default {
  data() {
    return {
      loading: false,
      finished: false,
      list: [],
      showArea: false,
      areaList: area,
      areaName: '全部地区',
      area: '',
      province: '',
      city: ''
    }
  },
  mounted() {
    this.onLoad()
    document.title = '欧洲维修门店列表'
  },
  methods: {
    onConfirm(values) {
      if (values[0].code === '0') {
        this.province = ''
        this.city = ''
        this.area = ''
        this.areaName = '全部省市区'
      } else {
        this.province = values[0].code
        this.city = values[1] && values[1].code
        this.area = values[2] && values[2].code
       /* if(this.area==''){
          values[2].name='全部地区'
        } */
        this.areaName = values.map((item) => item && item.name).join('/')
      }
      this.showArea = false
      this.onLoad()
    },
    phones(num) {
      window.location.href = 'tel:' + num
    },
    goLocation(data) {
      if (data.lat == '' || data.lng == '') {
        return
      }
      this.$wx.openLocation({
        latitude: Number(data.lat), // 纬度，浮点数，范围为90 ~ -90
        longitude: Number(data.lng), // 经度，浮点数，范围为180 ~ -180。
        name: data.address, // 位置名
        scale: 15,
        address: data.shopName, // 地址详情说明
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      })
    },
    onLoad(val) {
      this.loading = true
      const that = this
      if (process.env.NODE_ENV === 'development') {
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          message: '加载中'
        })
        getShopList({
          lat: '117.1311',
          lng: '36.67041',
          province: this.province,
          city: this.city,
          area: this.area
        }).then(res => {
          this.loading = false
          this.list = res
          this.finished = true
          this.$toast.clear()
        })
      } else {
        if (this.$wx) {
          this.$wx.getLocation({
            success: function(res) {
              that.$toast.loading({
                duration: 0,
                forbidClick: true,
                message: '加载中'
              })
              getShopList({
                lat: res.latitude,
                lng: res.longitude,
                province: that.province,
                city: that.city,
                area: that.area
              }).then(res => {
                that.loading = false
                that.list = res
                that.finished = true
                that.$toast.clear()
              }, err => {
                that.$toast.clear()
              })
            },
            cancel: function(res) {
              that.$toast.loading({
                duration: 0,
                forbidClick: true,
                message: '加载中'
              })
              getShopList({
                lat: res.latitude,
                lng: res.longitude
              }).then(res => {
                that.loading = false
                that.list = res
                that.finished = true
                that.$toast.clear()
              }, err => {
                that.$toast.clear()
              })
            }
          })
        } else {
          getShopList({
            lat: 0,
            lng: 0
          }).then(res => {
            that.$nextTick(() => {
              that.list = res.data
            })
          }).catch(err => {
            console.log(err)
          })
        }
      }
    }
  }
}
</script>
